import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export const setCompliantLocalStorageItem = createAction(`${reduxKey}/SET_ITEM`, (payload)=>payload);
export const removeCompliantLocalStorageItem = createAction(`${reduxKey}/REMOVE_ITEM`, (key)=>({
        key
    }));

//# sourceMappingURL=actions.js.map